import * as React from 'react';
import { DismissRegular } from '@fluentui/react-icons';
import {
  MessageBar,
  MessageBarActions,
  MessageBarTitle,
  MessageBarBody,
  Button,
  makeStyles,
} from '@fluentui/react-components';
import { ReactElement, useEffect, useState } from 'react';
import { p4Tokens } from '../../../../styles/themes/default/p4FluentTheme';

type FluentMessageBarPropsType = {
  title?: string;
  message?: string;
  onClose?: () => void;
  visible?: boolean;
  action?: ReactElement<any, any>;
};

const useOverrides = makeStyles({
  messageBar: {
    backgroundColor: p4Tokens.colorInfoBackground,
    borderInlineColor: p4Tokens.colorInfoStroke,
    borderBlockColor: p4Tokens.colorInfoStroke,
  },
  messageIcon: {
    color: p4Tokens.colorInfoIcon,
  },
});

export const FluentMessageBar = ({ title, message, visible, action, onClose }: FluentMessageBarPropsType) => {
  const overrides = useOverrides();
  const [messageBarVisible, setMessageBarVisible] = useState(visible);

  const handleOnClose = () => {
    setMessageBarVisible(false);
    onClose?.();
  };

  useEffect(() => {
    setMessageBarVisible(visible);
  }, [visible]);

  return (
    <>
      {messageBarVisible && (
        <MessageBar intent={'info'} className={overrides.messageBar} icon={{ className: overrides.messageIcon }}>
          <MessageBarBody>
            <MessageBarTitle>{title}</MessageBarTitle>
            {message}
          </MessageBarBody>
          <MessageBarActions
            containerAction={
              <Button aria-label="dismiss" appearance="transparent" icon={<DismissRegular />} onClick={handleOnClose} />
            }
          >
            {action}
          </MessageBarActions>
        </MessageBar>
      )}
    </>
  );
};
